// extracted by mini-css-extract-plugin
export default {"optionsSelect":"input_optionsSelect__6DMaF","input":"input_input__GkfZI"};